export default "__VITE_ASSET__Did4Zguk__"